<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <div class="flex items-center w-full">

        <!-- patient name - external reference - prototype -->
        <div class="flex flex-wrap">
            <!-- patient name -->
            <div class="text-sm text-gray-500">
                {{ patient }}
            </div>
            <!-- external reference -->
            <div v-if="row.order.extra?.ext_ref" class="ml-2 text-sm text-gray-500">
                {{ row.order.extra.ext_ref }}
            </div>
            <!-- prototype -->
            <div class="w-full text-xs text-gray-400 whitespace-nowrap text-ellipsis">
                {{ prototype }}
            </div>
        </div>

        <!-- side -->
        <div class="ml-auto flex items-center justify-center">
            <sl-lens-side :side="row.order.article_data.LENS_SIDE" />
        </div>

    </div>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

export default
{
    name: 'ReturnDetailsCell',

    props:
    {
        row:
        {
            type:     Object,
            required: true,
        },

        rows:
        {
            type:     Array,
            required: true,
        },

        column:
        {
            type:     Object,
            required: true,
        },

        updating:
        {
            type:    Boolean,
            default: false,
        },
    },

    computed:
    {
        patient()
        {
            if(this.row.order.article_data.PATIENT_REFERENCE1)
            {
                return this.row.order.article_data.PATIENT_REFERENCE1;
            }
            else if(this.row.order.article_data.PATIENT_ID)
            {
                const patient = this.$store.getters['patients/getById'](this.row.order.article_data.PATIENT_ID);

                return patient.reference1 ? patient.reference1 : '-';
            }
            else
            {
                return '-';
            }
        },

        prototype()
        {
            const prototypeCode = this.row.order.article_data?.PROTOTYPE_CODE || this.row.order.article_data?.PROTOTYPE_CODE_LEGACY;

            return this.$store.state.prototypes.prototypes.find(p => p.code === prototypeCode)?.label || prototypeCode;
        },
    },
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss" scoped>



</style>
